export const getRequiredTextMessage = obj => {
  return "".concat(obj, " is required.");
};
export const getMinCharactersTextMessage = (obj, count) => {
  return "".concat(obj, " should be at least ").concat(count, " characters.");
};
export const getMaxCharactersTextMessage = (obj, count) => {
  return "".concat(obj, " should not exceed ").concat(count, " characters.");
};
export const getMustMatchTextMessage = obj => {
  return "".concat(obj, " must match.");
};
export const getMustAcceptTextMessage = obj => {
  return "Must Accept ".concat(obj, ".");
};
export const getEnterValidTextMessage = obj => {
  return "Invalid ".concat(obj, ".");
};
export const lettersNummersUsTextMessage = 'You can use any combination of letters, numbers, and "_" symbol.';
export const passwordRulesTextMessage = 'Must contain at least 1 upper case, numeric, and special character.';